
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../../decorators'
import SH from '../../../../../lib/IssueMapping/SocialHistory'
import { LifeStyleQuestionnaire } from '../../../../../lib/Questionnaires'
import { IGAO } from '../../../../igao'
import * as Card from '../../../../shared/card'
import IssueQueuer from '../../../../shared/IssueQueuer'
import { CircularProgress } from '../../../../shared/NarusMaterial'
import * as Actions from '../../lib/new-actions'

import LifestyleForm from './form'

const CATEGORY = 'Lifestyle'

class Lifestyle extends Component {
  constructor (props) {
    super(props)
    this.state = { open: true }
    this.handleOpenChange = this.handleOpenChange.bind(this)
  }

  componentDidMount () {
    const { dispatch, params } = this.props
    dispatch(Actions.getAssessment(params.id, CATEGORY, LifeStyleQuestionnaire))
  }

  handleSubmit = data => {
    this.queueIssues(data)
    const { currentUser, dispatch, params, encounter } = this.props
    dispatch(
      Actions.createAssessment(
        data,
        params.id,
        currentUser.id,
        CATEGORY,
        encounter.document.context_id,
        LifeStyleQuestionnaire
      )
    )
  }

  handleOpenChange (value) {
    this.setState({ open: value })
  }

  onCancel = () => {
    const { dispatch, params } = this.props
    dispatch(
      Actions.getAssessment(params.id, CATEGORY, LifeStyleQuestionnaire)
    )
  }

  queueIssues = data => {
    const { dispatch, patientId, practitionerId, encounterId } = this.props
    const iq = new IssueQueuer({
      dispatch,
      patientId,
      practitionerId,
      encounterId
    })

    iq.queueIssues({
      mapping: SH.lifestyle,
      currentForm: data,
      existingForms: undefined
    })
  }

  render () {
    const { questionnaire } = this.props
    const formData = _.get(questionnaire, `[${CATEGORY}].formData`, {})
    const loading = _.get(questionnaire, `[${CATEGORY}].loading`)

    return (
      <div className='main'>
        <Card.Card expandable>
          <Card.Header >
            <h2>Lifestyle</h2>
          </Card.Header>
          <Card.ExpandableWrapper
            style={{ padding: '0 1rem 1rem 1rem' }}
          >
            {loading
              ? <CircularProgress />
              : (
                <LifestyleForm
                  formKey='lifestyle'
                  onSubmit={this.handleSubmit}
                  initialValues={formData}
                  cancel={this.onCancel}
                />
              )
            }
          </Card.ExpandableWrapper>
        </Card.Card>
        <IGAO path='lifestyle' />
      </div>
    )
  }
}

Lifestyle.contextTypes = {
  dispatch: PropTypes.instanceOf(Object)
}

const mapStateToProps = redux => ({
  questionnaire: redux.questionnaire,
  currentUser: redux.users.current_user,
  patientId: redux?.globalVars?.params?.id,
  practitionerId: redux.auth.profile.sub,
  encounter: redux.encounter?.encounter
})

export default connect(mapStateToProps)(withLegacyRouter(Lifestyle))
